<div>
	<caass-sub-main-table (PersonSelected)="onPersonSelected($event)"> </caass-sub-main-table>
</div>

<!-- <caass-sub-history-table
    [PersonID]="PersonID">
</caass-sub-history-table> -->

<div class="TopMarinExtra">
	<p-accordion>
		<p-accordionTab header="Substitute History {{ HistoryExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}" [(selected)]="HistoryExpand">
			<div>
				<caass-sub-history-table [PersonID]="PersonID"> </caass-sub-history-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>
